import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constants";
import { Button } from "../ui/button";
import { ArrowLeft } from "lucide-react";

type AuthPageChromeProps = {
  children: ReactNode;
  backLabel?: string;
};

/** Fundo e cabeçalho comuns às telas de login / cadastro (alinhado à landing). */
export function AuthPageChrome({ children, backLabel = "Voltar ao início" }: AuthPageChromeProps) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen overflow-x-clip bg-[#050a14] text-white">
      <div
        className="pointer-events-none fixed inset-0 opacity-[0.35]"
        style={{
          backgroundImage: `radial-gradient(circle at 20% 20%, rgba(45,212,191,0.12) 0%, transparent 45%),
            radial-gradient(circle at 80% 10%, rgba(6,182,212,0.1) 0%, transparent 40%),
            radial-gradient(circle at 50% 80%, rgba(139,92,246,0.08) 0%, transparent 45%)`,
        }}
      />
      <div
        className="pointer-events-none fixed inset-0 opacity-[0.04]"
        style={{
          backgroundImage: `linear-gradient(rgba(79,209,197,0.4) 1px, transparent 1px),
            linear-gradient(90deg, rgba(79,209,197,0.35) 1px, transparent 1px)`,
          backgroundSize: "48px 48px",
        }}
      />

      <header className="sticky top-0 z-50 border-b border-white/[0.08] bg-[#050a14]/90 backdrop-blur-xl">
        <div className="container mx-auto flex max-w-7xl items-center px-4 py-3 sm:px-6">
          <Button
            type="button"
            variant="ghost"
            onClick={() => navigate(ROUTES.HOME)}
            className="-ml-2 text-slate-200 hover:bg-white/10 hover:text-white"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            {backLabel}
          </Button>
        </div>
      </header>

      {children}
    </div>
  );
}

/** Cartão do formulário: vidro, canto arredondado (filete superior opcional no JSX). */
export const AUTH_FORM_CARD_CLASS =
  "relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-b from-white/[0.07] to-white/[0.025] p-6 shadow-2xl shadow-black/50 backdrop-blur-xl ring-1 ring-inset ring-white/[0.06] sm:p-8 !gap-0";
